import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow, IconButton, Box } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import ModalBarcode from '../common/ModalBarcode';

import { BiLinkExternal } from 'react-icons/bi';

const Property = ({ property }) => {
  const { url, address, nid, barcode, observations, problems, warehouse } =
    property;
  const navigate = useNavigate(); // habilitar navigate para redirección
  const [showBarcode, setShowBarcode] = useState(false);

  // función que redirige de forma programada
  const redirectEdition = (id) => {
    navigate(`/properties/edit/${id}`, { replace: true });
  };

  return (
    <TableRow key={nid}>
      <TableCell component='th' scope='row'>
        {nid}
      </TableCell>
      <TableCell>
        {url ? (
          <a
            href={url}
            target='_blank'
            rel='noreferrer'
            className='flex items-center justify-center underline'
            style={{ color: '#7C01FF', textDecoration: 'underline' }}
          >
            Explorar <BiLinkExternal className='ml-1' />
          </a>
        ) : (
          ''
        )}
      </TableCell>
      <TableCell>{address}</TableCell>
      <TableCell>
        {problems?.length > 0 && (
          <div className='bg-blue-100 text-black p-3 rounded-lg'>
            {problems.map((item) => {
              if (Number(item.problem_id) === 7) {
                return (
                  <p
                    key={item.id}
                    className={problems.length >= 2 ? 'pt-4' : ''}
                  >
                    <span className='font-bold'>Observación:</span> <br />{' '}
                    {observations}
                  </p>
                );
              } else {
                return <p key={item.id}>* {item.description}</p>;
              }
            })}
          </div>
        )}
        {!problems?.length && !!observations && (
          <div className='bg-blue-100 text-black p-3 rounded-lg'>
            <p>
              <span className='font-bold'>Observación:</span> <br />{' '}
              {observations}
            </p>
          </div>
        )}
      </TableCell>
      <TableCell>
        <Box sx={{ textAlign: 'center', width: 'max-content', margin: 'auto' }}>
          <IconButton
            aria-label='editar'
            size='medium'
            onClick={() => setShowBarcode(true)}
            title='imprimir código'
            variant='outlined'
          >
            <img width='25px' src='/barcode-icon.svg' alt='' />
          </IconButton>
          <Box sx={{ fontSize: '10px' }}>{barcode}</Box>
        </Box>
      </TableCell>
      <TableCell>
        <Box sx={{ textAlign: 'center', width: 'max-content', margin: 'auto' }}>
          <p>{warehouse}</p>
        </Box>
      </TableCell>
      <TableCell align='right'>
        <IconButton
          aria-label='editar'
          size='medium'
          onClick={() => redirectEdition(property.nid)}
        >
          <Edit color='action' />
        </IconButton>
      </TableCell>
      {showBarcode && (
        <ModalBarcode barcode={barcode} onClose={() => setShowBarcode(false)} />
      )}
    </TableRow>
  );
};

export default Property;
